"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _heading = _interopRequireDefault(require("../heading"));
var _icon = _interopRequireDefault(require("../icon"));
var _chevronLeft = _interopRequireDefault(require("../../icons/chevron-left"));
require("./subnav.css");
var _excluded = ["tagName", "className"],
  _excluded2 = ["active"],
  _excluded3 = ["children"],
  _excluded4 = ["children", "customComponent", "containerClassName", "includeLink", "headingTagName", "id"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var NavLink = function NavLink(_ref) {
  var TagName = _ref.tagName,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(TagName, _extends({
    className: "text-noUnderline ".concat(className || '')
  }, otherProps));
};
NavLink.defaultProps = {
  tagName: 'a'
};
var SubnavItem = function SubnavItem(_ref2) {
  var active = _ref2.active,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var activeClass = active ? 'text-semibold color-textBlack sb-subnav-link--active' : 'color-textBlackSoft';
  return /*#__PURE__*/_react["default"].createElement(NavLink, _extends({
    "aria-current": active ? 'page' : null,
    className: "sb-subnav-listLink text-sm ".concat(activeClass)
  }, otherProps));
};
var SubnavList = function SubnavList(_ref3) {
  var items = _ref3.items;
  if (!items || items.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: "lg-mt5 sb-subnav-list"
  }, items.map(function (item, i) {
    if (!item.children) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "sb-subnav-listItem",
      key: i
    }, /*#__PURE__*/_react["default"].createElement(SubnavItem, item));
  }));
};
var SubnavBreadcrumb = function SubnavBreadcrumb(_ref4) {
  var children = _ref4.children,
    otherProps = _objectWithoutProperties(_ref4, _excluded3);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb3 lg-mb5"
  }, /*#__PURE__*/_react["default"].createElement(NavLink, _extends({
    className: "color-textBlackSoft text-sm text-bold position-relative flex items-center sb-subnav-breadcrumb"
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "sb-subnav-breadcrumbIcon mr1",
    path: _chevronLeft["default"],
    size: "18px"
  }), /*#__PURE__*/_react["default"].createElement("span", null, children)));
};
var SubnavPrimary = function SubnavPrimary(_ref5) {
  var children = _ref5.children,
    Component = _ref5.customComponent,
    containerClassName = _ref5.containerClassName,
    includeLink = _ref5.includeLink,
    headingTagName = _ref5.headingTagName,
    id = _ref5.id,
    otherProps = _objectWithoutProperties(_ref5, _excluded4);
  if (Component) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      id: id
    }, /*#__PURE__*/_react["default"].createElement(Component, null));
  }
  if (!children) {
    return null;
  }
  var content = includeLink ? /*#__PURE__*/_react["default"].createElement(NavLink, _extends({
    children: children
  }, otherProps)) : children;
  return /*#__PURE__*/_react["default"].createElement(_heading["default"], {
    className: "".concat(containerClassName || '', " sb-subnav-heading text-bold"),
    id: id,
    size: "lg",
    tagName: headingTagName
  }, content);
};
SubnavPrimary.defaultProps = {
  headingTagName: 'p',
  includeLink: true
};

/**
 * A subnav element for use in the `HeaderCrate`. Includes an optional primary link/page title,
 * an optional breadcrumb link, and a list of links, rendered as scrolling tabs on small screens
 * and as a stacked list on large screens.
 */
var Subnav = function Subnav(_ref6) {
  var primary = _ref6.primary,
    items = _ref6.items,
    breadcrumb = _ref6.breadcrumb;
  var subnavPrimaryId = 'subnavPrimaryId';
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SubnavBreadcrumb, breadcrumb), /*#__PURE__*/_react["default"].createElement(SubnavPrimary, _extends({}, primary, {
    id: subnavPrimaryId
  })), /*#__PURE__*/_react["default"].createElement("nav", {
    "aria-labelledby": subnavPrimaryId
  }, /*#__PURE__*/_react["default"].createElement(SubnavList, {
    items: items
  })));
};
Subnav.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Props for the breadcrumb nav item. Passes any unrecognized props
   * along to the rendered link, allowing you to include event handlers, DOM attributes,
   * children, and more.
   */
  breadcrumb: _propTypes["default"].shape({
    /**
     * Content for the 'back' breadcrumb, can be a string or a component
     */
    children: _propTypes["default"].any.isRequired,
    /**
     * HTML element or React component to use for this item. Defaults to `a`.
     */
    tagName: _propTypes["default"].any
  }),
  /**
   * Props for the primary nav item or page title. Passes any unrecognized props
   * along to the rendered link, allowing you to include event handlers, DOM attributes,
   * children, and more.
   */
  primary: _propTypes["default"].shape({
    /**
     * Content for the primary link, can be a string or a component
     */
    children: _propTypes["default"].any.isRequired,
    /**
     * CSS class applied to the heading wrapper of the primary breadcrumb
     */
    containerClassName: _propTypes["default"].string,
    /**
     * Allows the user to pass in a custom element instead of the opinionated
     * default Primary component.
     */
    customComponent: _propTypes["default"].any,
    /**
     * Optional tagName for primary nav item. Defaults to `p`, but can be set
     * to `h1`, `h2`, etc depending on needs.
     */
    headingTagName: _propTypes["default"].any,
    /**
     * Flag to optionally disable rendering the primary item as a link. If
     * `includeLink` is `false`, the primary item is rendered as text, not a link.
     */
    includeLink: _propTypes["default"].bool,
    /**
     * HTML element or React component to use for this item. Defaults to `a`.
     */
    tagName: _propTypes["default"].any
  }),
  /**
   * An array of nav item props objects. Passes any unrecognized props
   * along to the rendered links, allowing you to include event handlers, DOM attributes,
   * children, and more.
   */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    /**
     * Flag to apply when a user is on the page matching this nav item.
     * Adds an underline and adjusted text styles to active items.
     */
    active: _propTypes["default"].bool,
    /**
     * Content for each list item, can be a string or a component
     */
    children: _propTypes["default"].any.isRequired,
    /**
     * HTML element or React component to use for this item. Defaults to `a`.
     */
    tagName: _propTypes["default"].any
  }))
} : {};
Subnav.displayName = 'Subnav';
var _default = exports["default"] = Subnav;